module.exports = __webpack_public_path__ + "static/img/increase-lead-data04.8c9df28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/increase-lead-data04.jpg
// module id = CC7N
// module chunks = 1